var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qm-picture-library-detail-dialog" },
    [
      _vm.isShowMoreImage
        ? [
            _c(
              "el-scrollbar",
              { attrs: { wrapStyle: "height:482px;overflow-x:hidden;" } },
              [
                _vm.selectImages && _vm.selectImages.length
                  ? _c(
                      "div",
                      { staticClass: "image-more-info" },
                      _vm._l(_vm.selectImages, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "image-more-info_item",
                            class: {
                              "qm-upload__info_img": _vm.galleryShowType === 2,
                            },
                          },
                          [
                            _vm.galleryShowType === 1
                              ? _c("img", {
                                  attrs: {
                                    src: item.domain + "/" + item.path,
                                    alt: "",
                                  },
                                })
                              : _c("img", {
                                  attrs: {
                                    src: item.coverUrl
                                      ? item.coverUrl
                                      : "https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png",
                                    alt: "",
                                  },
                                }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            ),
          ]
        : [
            _vm.imageInfo
              ? [
                  _vm.galleryShowType === 1
                    ? _c("div", { staticClass: "image-box" }, [
                        _c("img", {
                          staticClass: "image-detail",
                          attrs: { src: _vm.imageInfo.path },
                        }),
                      ])
                    : _c(
                        "div",
                        { staticClass: "qm-upload__image-box" },
                        [
                          _c("Dplayer", {
                            ref: "player",
                            attrs: { options: _vm.playOptions },
                          }),
                        ],
                        1
                      ),
                  _c("div", { staticClass: "info-form" }, [
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.galleryShowType === 1
                                ? " 图片名："
                                : " 文件名称："
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-content" },
                        [
                          _c(
                            "span",
                            { staticClass: "truncate" },
                            [
                              _vm.imageInfo.isShowPictureName
                                ? _c("el-input", {
                                    attrs: { size: "small", spellcheck: false },
                                    model: {
                                      value: _vm.imageInfo.partName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.imageInfo, "partName", $$v)
                                      },
                                      expression: "imageInfo.partName",
                                    },
                                  })
                                : [_vm._v(_vm._s(_vm.imageInfo.name))],
                            ],
                            2
                          ),
                          _vm.galleryType
                            ? [
                                _vm.imageInfo.isShowPictureName
                                  ? _c("i", {
                                      staticClass: "qm-icon qm-icon-success",
                                      on: { click: _vm.saveImageInfo },
                                    })
                                  : _c("i", {
                                      staticClass: "qm-icon qm-icon-edit",
                                      on: {
                                        click: function ($event) {
                                          _vm.imageInfo.isShowPictureName = true
                                        },
                                      },
                                    }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("文件路径："),
                      ]),
                      _c("div", { staticClass: "form-content" }, [
                        _c("span", { staticClass: "truncate" }, [
                          _vm._v(_vm._s(_vm.imageInfo.path)),
                        ]),
                        _c("i", {
                          staticClass: "qm-icon qm-icon-copy tag-read",
                          attrs: {
                            "data-clipboard-text": "" + _vm.imageInfo.path,
                          },
                          on: { click: _vm.copyPath },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.galleryShowType === 1
                              ? " 图片大小："
                              : " 文件大小："
                          )
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-content" },
                        [
                          _vm.imageInfo.size
                            ? [
                                _vm.galleryShowType === 1
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("imageSize")(
                                              _vm.imageInfo.size
                                            )
                                          ) +
                                          "KB "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("videoSize")(
                                              _vm.imageInfo.size
                                            )
                                          ) +
                                          "MB "
                                      ),
                                    ]),
                              ]
                            : _c("span", [_vm._v("暂无")]),
                        ],
                        2
                      ),
                    ]),
                    _vm.galleryShowType === 1
                      ? _c("div", { staticClass: "form-item" }, [
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v("图片比例："),
                          ]),
                          _c(
                            "div",
                            { staticClass: "form-content" },
                            [
                              _vm.imageInfo.width
                                ? [
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.imageInfo.width) +
                                          "x" +
                                          _vm._s(_vm.imageInfo.height) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                : _c("span", [_vm._v("暂无")]),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("上传时间："),
                      ]),
                      _c("div", { staticClass: "form-content" }, [
                        _vm._v(_vm._s(_vm.imageInfo.createTime)),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("修改时间："),
                      ]),
                      _c("div", { staticClass: "form-content" }, [
                        _vm._v(_vm._s(_vm.imageInfo.updateTime)),
                      ]),
                    ]),
                    _vm.galleryType
                      ? _c("div", { staticClass: "form-item" }, [
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v("备注："),
                          ]),
                          _c(
                            "div",
                            { staticClass: "form-content" },
                            [
                              _c(
                                "span",
                                { staticClass: "truncate" },
                                [
                                  _vm.imageInfo.isShowDescription
                                    ? _c("el-input", {
                                        attrs: {
                                          size: "small",
                                          spellcheck: false,
                                        },
                                        model: {
                                          value: _vm.imageInfo.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.imageInfo,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "imageInfo.description",
                                        },
                                      })
                                    : [
                                        _vm._v(
                                          _vm._s(_vm.imageInfo.description)
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm.galleryType
                                ? [
                                    _vm.imageInfo.isShowDescription
                                      ? _c("i", {
                                          staticClass:
                                            "qm-icon qm-icon-success",
                                          on: { click: _vm.saveImageInfo },
                                        })
                                      : _c("i", {
                                          staticClass: "qm-icon qm-icon-edit",
                                          on: {
                                            click: function ($event) {
                                              _vm.imageInfo.isShowDescription = true
                                            },
                                          },
                                        }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              : _c("div", { staticClass: "no-select-text" }, [
                  _vm._v("没有选中"),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }